import gsap from "gsap";
import $ from "jquery";
import utils from "../utils";
import canvasUtils from "../utils/canvas";

let { drawImageProp, loadAssets, preloadImages, load } = canvasUtils;

let { isPortrait } = utils;

export default function Video({path, canvas, counter = 840, onUpdateCallback = null}) {
    this.path = path;
    this.counter = counter;
    // this.canvas = canvas;

    // let canvas = this.canvas;
    let ctx = canvas.getContext("2d");
    let playhead = { currentImage: 0 };

    let imgUrl = isPortrait
      ? this.path
      : this.path;

    this.video = {
      prefix: "",
      imagesLength: this.counter,
      path: imgUrl,
    };

    this.video2 = {
      prefix: "",
      imagesLength: 100,
      path: imgUrl,
    };

    let loadedItems = [
      ...Array(this.video.imagesLength - this.video2.imagesLength),
    ].map(() => {
      return {
        img: false,
        loaded: false,
      };
    });

    let loadedCounter = this.video2.imagesLength - 1;

    load(this.video2).then((images) => {
      const { sx = 0, sy = 0 } = { sx: 0, sy: 0 };

      loadedItems = [
        ...images.map((elem) => {
          return {
            img: elem,
            loaded: true,
          };
        }),
        ...loadedItems,
      ];

      let timeout = 0;

      for (
        let nextIndex = loadedCounter;
        nextIndex < this.video.imagesLength;
        nextIndex++
      ) {
        let nextImg = loadedItems[nextIndex];

        setTimeout(
          (ix) => {
            if (!nextImg.loaded) {
              nextImg.loaded = true;
              const PATH = `${imgUrl}${String(nextIndex).padStart(3, "0")}.webp?auto=compress,format`;
              loadAssets(PATH).then((img) => {
                nextImg.img = img;
              });
            }
          },
          20 * timeout,
          timeout
        );

        timeout++;
      }

      ctx.canvas.width = images[0].width;
      ctx.canvas.height = images[0].height;

      drawImageProp(ctx, images[0], 0, 0, images[0].width, images[0].height);

      $(window).resize(function () {
        const img = loadedItems[playhead.currentImage].img;

        ctx.canvas.width = img.width;
        ctx.canvas.height = img.height;
        if (img) drawImageProp(ctx, img, 0, 0, img.width, img.height);
      });
    });

    this.goToPoint = (point, duration, counter, ease) => {
      gsap.to(playhead, {
        currentImage: point,
        roundProps: "currentImage",
        immediateRender: false,
        ease: ease || "none",
        duration: duration,
        onUpdate: () => {
          if( loadedItems[playhead.currentImage] ) {
            const img = loadedItems[playhead.currentImage].img;

            ctx.canvas.width = img.width;
            ctx.canvas.height = img.height;
            if (img) drawImageProp(ctx, img, 0, 0, img.width, img.height)
            if (onUpdateCallback) {
              onUpdateCallback(playhead);
            }
          }
        },
      });
    };
}